import { dataTypes, tagsHoursLimit } from "constant";

export const checkDefault = (v, def) => (v === null || v === "" ? def : v);

export const getDataTypeTitle = (id) => {
  const dataType = dataTypes.find((x) => x.id === id);
  return dataType && dataType.title;
};

export const generateHierarchicalData = (data, widgetParentId = null) => {
  return data.reduce((r, e) => {
    let obj = Object.assign({}, e);
    if (widgetParentId == e.widgetParentId) {
      let children = generateHierarchicalData(data, e.id);
      children.sort((a, b) => a.index - b.index);
      if (children.length) obj.children = children;
      if (obj.type === "container") obj.expanded = true;
      r.push(obj);
    }
    r.sort((a, b) => a.index - b.index);
    return r;
  }, []);
};

export const parseParams = (params) => {
  const keys = Object.keys(params);
  let options = "";

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === "object";
    const isParamTypeArray = isParamTypeObject && params[key].length >= 0;

    if (!isParamTypeObject) {
      options += `${key}=${params[key]}&`;
    }

    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach((element) => {
        options += `${key}=${element}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
};

export const durationToMiliseconds = (days, hours, minutes, seconds) => {
  let d = 0;
  let h = 0;
  let m = 0;
  let s = 0;
  if (days > 0) {
    d = days * 24 * 60 * 60 * 1000;
  }
  if (hours > 0) {
    h = hours * 60 * 60 * 1000;
  }
  if (minutes > 0) {
    m = minutes * 60 * 1000;
  }
  if (seconds > 0) {
    s = seconds * 1000;
  }

  return d + h + m + s;
};

export const milisecondsToDuration = (miliseconds) => {
  let day = 0;
  let hour = 0;
  let minute = 0;
  let second = 0;
  if (miliseconds > 0) {
    day = Math.floor(miliseconds / (24 * 60 * 60 * 1000));
    miliseconds -= day * (24 * 60 * 60 * 1000);
    hour = Math.floor(miliseconds / (60 * 60 * 1000));
    miliseconds -= hour * (60 * 60 * 1000);
    minute = Math.floor(miliseconds / (60 * 1000));
    miliseconds -= minute * (60 * 1000);
    second = Math.floor(miliseconds / 1000);
  }
  return { day, hour, minute, second };
};

export const durationToDays = (years, months, days) => {
  let d = 0;
  if (years > 0) {
    d += years * 365;
  }
  if (months > 0) {
    d += months * 30;
  }
  return d + days;
};

export const getMaxSpan = (tags) => {
  if (tags > 0) {
    const t = tagsHoursLimit.find((x) => x.tags === tags);
    const day = Math.floor(t.hours / 24);
    const hour = (t.hours / 24).toFixed(1).toString().split(".")[1];
    return { day, hour: parseInt(hour) };
  }
  return { day: 32, hour: 4 };
};

export const countPaginationRange = (meta, entity) => `${
  meta.totalItems > 0 ? meta.pageSize * meta.page - meta.pageSize + 1 : 0
} -
${meta.pageSize * meta.page > meta.totalItems ? meta.totalItems || 0 : meta.pageSize * meta.page || 0}
OF ${meta.totalItems || 0} ${entity} `;

export const breakTextNicely = (text, limit, breakpoints) => {
  var parts = text.toString().split(" ");
  var lines = [];
  text = parts[0];
  parts.shift();

  while (parts.length > 0) {
    var newText = `${text} ${parts[0]}`;

    if (newText.length > limit) {
      lines.push(`${text}\n`);
      breakpoints--;

      if (breakpoints === 0) {
        lines.push(parts.join(" "));
        break;
      } else {
        text = parts[0];
      }
    } else {
      text = newText;
    }
    parts.shift();
  }

  if (lines.length === 0) {
    return text;
  } else {
    return lines.join("");
  }
};
